import React from 'react';
import Row from '../../layout/Row';
import Input from '../../forms/Input';
import { QuestRoute } from '../../api/QuestRoutes';
import Preput from '../../forms/Preput';
import FormSetting from '../../layout/FormSetting';
import PageBreak from '../../layout/PageBreak';
import TextArea from '../../forms/TextArea';
import HamQuest from '../../api/HamQuestGiver';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';
import { userRoles } from '../../RoleProtected';
import { customInput } from './SingleUseCodes';


const Settings = ({ ...props }) => {

    return (
        <PageBreak>
            <FormSetting
                label='Wash Bundle Settings'
                getInputs={QuestRoute.codes.washBundleSettings}
                onSubmit={e => HamQuest.put(QuestRoute.codes.washBundleSettings, e)}
                editable
                roles={userRoles.accountConfiguration}
            >
                {(values) => <>
                    <PageBreak>
                        <AutoSelectAndUpgrade
                            upgrades='allowUpgrades'
                            select='autoSelect'
                            values={values}
                        />

                        <Preput
                            label='Issue Receipt'
                            name='issueMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        />
                        <Preput
                            label='Receipt'
                            name='receiptMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        />

                        {/* <TextArea
                            label='Issue Receipt'
                            name='issueMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        />
                        <TextArea
                            label='Receipt'
                            name='receiptMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        /> */}
                    </PageBreak>
                </>}
            </FormSetting>

            <FormSetting
                label='Single Use Defaults'
                getInputs={QuestRoute.codes.singleUseSettings}
                onSubmit={e => HamQuest.put(QuestRoute.codes.singleUseSettings, { ...e })}
                editable
            >
                {({ values, setValues }) =>
                    <>
                        <span>Default Expiration Time (Max {values.maxDays} days)</span>
                        <Row>
                            <Input
                                label='Days'
                                name='expirationDays'
                                type='number'
                                min={0}
                                max={values.maxDays}
                                onInput={(e) => customInput(e.target.value, values.expirationHours, values.expirationMinutes, setValues, values.maxDays)}
                                required
                            />
                            <Input
                                label='Hours'
                                name='expirationHours'
                                type='number'
                                min={0}
                                max={2880}
                                onInput={(e) => customInput(values.expirationDays, e.target.value, values.expirationMinutes, setValues, values.maxDays)}
                                required
                            />
                            <Input
                                label='Minutes'
                                name='expirationMinutes'
                                type='number'
                                min={0}
                                max={172800}
                                onInput={(e) => customInput(values.expirationDays, values.expirationHours, e.target.value, setValues, values.maxDays)}
                                required
                            />
                        </Row>
                        <Preput
                            label='Default Message'
                            name='defaultSingleUseCodeMsg'
                        />
                    </>
                }
            </FormSetting>
        </PageBreak>
    );
}

export default Settings;